"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoFixesCouldBeAppliedError = void 0;
const custom_error_1 = require("./custom-error");
class NoFixesCouldBeAppliedError extends custom_error_1.CustomError {
    constructor(message, tip) {
        super(message || 'No fixes could be applied', custom_error_1.ERROR_CODES.NoFixesCouldBeApplied);
        this.tip = tip;
    }
}
exports.NoFixesCouldBeAppliedError = NoFixesCouldBeAppliedError;
//# sourceMappingURL=no-fixes-applied.js.map